import clsx from 'clsx';
import { Recipient, RecipientActionsType } from './interface';
import styles from './ManageRecipients.module.scss';
import { Button } from '../../button/Button';
import { IconButton } from '../../button/IconButton/IconButton';
import { Icon } from '../../icon/Icon';
import { ACTION_ICON_MAP } from './constant';
import { TableRow } from '../../table/interfaces/table';

export function RecipientActions({ rowData }: { rowData: TableRow<Recipient> }) {
  const { data, actionHandlers, active } = rowData;
  return (
    <div className={styles.actionsContainer} data-id='recipient-actions'>
      {data.actions.map(action => {
        return (
          <>
            {action.type === RecipientActionsType.SWITCH && !active ? (
              <Button
                dataId={action.type}
                size='sm'
                icon={ACTION_ICON_MAP[action.type]}
                onClick={() => actionHandlers![action.type](data)}
              >
                switch
              </Button>
            ) : null}

            {action.type !== RecipientActionsType.SWITCH ? (
              <IconButton
                label=''
                dataId={action.type}
                disableRipple
                className={clsx(
                  'ml-2 p-1',
                  action.type === RecipientActionsType.DELETE && 'text-error'
                )}
                disableFocusRipple
                edge='start'
                onClick={() => actionHandlers![action.type](data)}
              >
                <Icon name={ACTION_ICON_MAP[action.type as keyof typeof ACTION_ICON_MAP]} />
              </IconButton>
            ) : null}
          </>
        );
      })}
    </div>
  );
}
